module.exports = __webpack_public_path__ + "static/media/beauty-dept-reinvention.2a8d737c.png";